import {createContext, useContext, PropsWithChildren} from 'react';

import {ActiveFilterSectionContent} from 'filters/features/FilterDialog/types';

type ActiveFiltersState = {
  overrideContent?: (content: ActiveFilterSectionContent) => ActiveFilterSectionContent;
  loading?: boolean;
};

const ActiveFiltersContext = createContext<ActiveFiltersState>(null as never);

export const useActiveFiltersContext = () => {
  const context = useContext(ActiveFiltersContext);

  if (!context) {
    throw new Error('useActiveFiltersContext must be used within an ActiveFiltersProvider');
  }

  return context;
};

export const ActiveFiltersProvider = ({children, ...value}: PropsWithChildren<ActiveFiltersState>) => {
  return <ActiveFiltersContext.Provider value={value}>{children}</ActiveFiltersContext.Provider>;
};
